module.exports = __webpack_public_path__ + "static/img/img-4-3.11c0bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/img-4-3.jpg
// module id = 2Gw7
// module chunks = 0